// 首页
<template>
  <div class="RAX-custom-main">
    <div class="first-column">
      <!-- 证书查询 -->
      <div class="first-column-left flex-column">
        <div class="search-top">证书查询</div>

        <div class="RAX-custom-box">
          <el-form ref="form" :model="form" size="small" label-width="80px">
            <el-form-item label="姓名:">
              <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
            </el-form-item>

            <el-form-item label="身份证号:">
              <el-input v-model="form.idcard" placeholder="请输入身份证号"></el-input>
            </el-form-item>

            <el-form-item label="证书编号:">
              <el-input v-model="form.code" placeholder="请输入证书编号"></el-input>
            </el-form-item>

            <div class="remarks">
              <p>注:&nbsp;&nbsp;任意输入以上两项内容即可查询。</p>
            </div>

            <el-form-item label="" style="margin-bottom: 0;">
              <el-button type="primary" class="RAX-common-but_one" @click="submitForm()">立即查询</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <!-- 证书样式 -->
      <div class="first-column-right flex-column">
        <div class="row-header">
          <p>证书样式</p>
        </div>

        <div class="RAX-custom-box flex-row" style="align-items: flex-end; justify-content: space-between;">
          <div class="certificate-style-item">
            <img :src="cover" alt="">
          </div>

          <div class="certificate-style-item">
            <img :src="inside" alt="">
          </div>
        </div>
      </div>
    </div>

    <div class="second-column flex-column">
      <div class="row-header">
        <p>新闻公告</p>
      </div>

      <div class="RAX-custom-box">
        <div v-for="item in 3" :key="item" class="notice-item flex-row">
          <p>2018年健康指导师专业能力（中级）鉴定考试圆满结束通知</p>
          <span>[&nbsp;&nbsp;2020-09-10&nbsp;&nbsp;]</span>
        </div>
      </div>
    </div>

    <div class="third-column flex-column">
      <div class="row-header">
        <p>证书查询</p>
      </div>

      <div class="RAX-custom-box">
        <div class="query-sub-item icon_cxfs">
          <div class="query-sub-item_title">查询方式</div>

          <div class="query-sub-item_box">
            <span>「任意输入两项组合内容即可查询」</span>
            <p>1、姓名 + 身份证号</p>
            <p>2、姓名 + 证书编号</p>
            <p>3、身份证号 + 证书编号</p>
          </div>
        </div>

        <div class="query-sub-item icon_zysx">
          <div class="query-sub-item_title">注意事项</div>

          <div class="query-sub-item_box">
            <div class="matter-item">
              <span>1</span>
              <p>健康指导师专业能力证书查询系统仅限于查询中科华予（北京）健康医学研究院和健康指导师专业能力培训（全国）管理办公室联合颁发的职业资格证书;</p>
            </div>

            <div class="matter-item">
              <span>2</span>
              <p>健康指导师专业能力证书上传和审核需要一定的时间周期，如急需核实证书真伪，可致电<i>028-87775609</i></p>
            </div>
          </div>
        </div>

        <div class="query-sub-item icon_gywm">
          <div class="query-sub-item_title">关注我们</div>

          <div class="query-sub-item_box">
            <div class="QR-code">
              <img :src="QRCode" alt="">
            </div>

            <div class="QR-code-text">
              <p>微信扫一扫</p>
              <p>微信公众号</p>
              <p>华予研究院</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Home',
  data() {
    return {
      cover: require('@/assets/images/certificate-cover.jpg'),
      inside: require('@/assets/images/certificate-inside.jpg'),
      QRCode: require('@/assets/images/ewm.jpg'),
      form: {
        name: '',
        idcard: '',
        code: ''
      }
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    submitForm() {
      let _flag = this.validate();

      if (!this.form.name && !this.form.idcard && !this.form.code) {
        this.$message({
          message: '请输入任意两项内容进行查询！',
          type: 'warning'
        });
        return false;
      }

      if (!_flag) return false;

      this.$router.push({
        name: 'About',
        query: {
          name: this.form.name,
          idcard: this.form.idcard,
          code: this.form.code,
        }
      })
    },

    validate() {
      if (this.form.name) {
        if (this.form.idcard) return true;

        if (this.form.code) return true;

        this.$message({
          message: '请输入身份证号或证书编号！',
          type: 'warning'
        });

        return false;
      }

      if (this.form.idcard) {
        if (this.form.name) return true;

        if (this.form.code) return true;

        this.$message({
          message: '请输入姓名或证书编号！',
          type: 'warning'
        });

        return false;
      }

      if (this.form.code) {
        if (this.form.name) return true;

        if (this.form.idcard) return true;

        this.$message({
          message: '请输入姓名或身份证号！',
          type: 'warning'
        });

        return false;
      }

      return false;
    }
  }
}
</script>

<style lang="scss" scoped>
.RAX-custom-main{
  .first-column{
    display: flex;
    width: 100%;
    margin-bottom: 24px;

    .first-column-left{
      width: 402px;
      background-color: #F5F6FA;
      border: 1px solid #c9c9c9;
      border-radius: 5px;
      box-sizing: border-box;

      .search-top{
        display: flex;
        width: 100%;
        height: 46px;
        padding: 0 40px;
        align-items: center;
        background: url("~@/assets/images/icon_search.png") no-repeat 10px center/28px 28px;
        border-bottom: 1px solid #c9c9c9;
        box-sizing: border-box;
      }

      .RAX-custom-box{
        padding: 20px 30px;
        box-sizing: border-box;

        .remarks{
          width: 100%;
          height: 20px;
          padding-left: 80px;
          margin-bottom: 10px;
          box-sizing: border-box;

          p{
            line-height: 20px;
            font-size: 12px;
            color: #777777;
          }
        }

        ::v-deep .el-form{
          .el-form-item{
            margin-bottom: 10px;

            .el-form-item__label{
              font-size: 14px;
              color: #000000;
            }
          }
        }
      }
    }

    .first-column-right{
      flex: 1;
      margin-left: 20px;
      overflow: hidden;

      .certificate-style-item{
        padding: 18px;
        border: 1px solid #c9c9c9;
        box-sizing: border-box;

        img{
          display: block;
          width: 260px;
        }
      }
    }
  }

  .second-column{
    width: 100%;
    margin-bottom: 24px;

    .RAX-custom-box{
      width: 100%;
      padding: 15px 25px;
      margin-top: 15px;
      border: 1px solid #0056a2;
      border-radius: 5px;
      box-sizing: border-box;

      .notice-item{
        width: 100%;
        cursor: pointer;

        & + .notice-item{
          padding-top: 15px;
          margin-top: 15px;
          border-top: 1px dashed #d2d2d2;
        }

        &:hover{
          p{
            color: #0147eb;
          }
        }

        p{
          flex: 1;
          line-height: 25px;
          font-size: 14px;
          color: #545454;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }

        span{
          display: inline-block;
          line-height: 25px;
          margin-left: 15px;
          font-size: 14px;
          color: #a2a2a2;
        }
      }
    }
  }

  .third-column{
    .RAX-custom-box{
      display: flex;
      margin-top: 15px;
      justify-content: space-between;

      .query-sub-item{
        width: 335px;
        box-sizing: border-box;
        overflow: hidden;

        &.icon_cxfs{
          .query-sub-item_title{
            background-image: url("~@/assets/images/icon_cxfs.png");
            background-repeat: no-repeat;
            background-position: 8px center;
            background-size: 36px 36px;
          }

          .query-sub-item_box{
            span{
              display: inline-block;
              line-height: 25px;
              margin-bottom: 8px;
              font-size: 16px;
              color: #0056a2;
            }

            p{
              line-height: 25px;
              font-size: 14px;
              color: #545454;
            }
          }
        }

        &.icon_zysx{
          .query-sub-item_title{
            background-image: url("~@/assets/images/icon_zysx.png");
            background-repeat: no-repeat;
            background-position: 8px center;
            background-size: 36px 36px;
          }

          .query-sub-item_box{
            .matter-item{
              display: flex;

              span{
                display: inline-block;
                width: 15px;
                height: 15px;
                margin-top: 5px;
                text-align: center;
                font-size: 14px;
                color: #FFFFFF;
                background-color: #0056a2;
                border-radius: 100%;
              }

              p{
                flex: 1;
                margin-left: 5px;
                line-height: 25px;
                font-size: 14px;
                color: #545454;
              }

              i{
                font-style: normal;
                color: #0056a2;
              }
            }
          }
        }

        &.icon_gywm{
          .query-sub-item_title{
            background-image: url("~@/assets/images/icon_gywm.png");
            background-repeat: no-repeat;
            background-position: 8px center;
            background-size: 36px 36px;
          }

          .query-sub-item_box{
            display: flex;
            width: 100%;
            align-items: center;
            justify-content: space-between;

            .QR-code{
              width: 156px;

              img{
                display: block;
                width: 100%;
              }
            }

            .QR-code-text{
              padding: 0 15px;
              box-sizing: border-box;

              p{
                line-height: 30px;
                font-size: 16px;
                color: #545454;
              }
            }
          }
        }

        .query-sub-item_title{
          width: 100%;
          height: 40px;
          padding-left: 60px;
          line-height: 40px;
          background-color: #0056a2;
          font-size: 16px;
          color: #FFFFFF;
          border-radius: 5px 5px 0 0;
          box-sizing: border-box;
        }

        .query-sub-item_box{
          width: 100%;
          height: 230px;
          padding: 20px;
          background-color: #FFFFFF;
          border: 1px solid #0056a2;
          border-top: 0 none;
          border-radius: 0 0 5px 5px;
          box-sizing: border-box;
        }
      }
    }
  }
}

.RAX-custom-box{
  flex: 1;
}


.row-header{
  display: flex;
  width: 100%;
  height: 30px;
  padding: 0 16px;
  align-items: center;
  background: url("~@/assets/images/icon_title_bg.jpg") no-repeat left center/136px 30px;
  border-bottom: 2px solid #0056a2;
  box-sizing: border-box;

  p{
    font-size: 18px;
    color: #FFFFFF;
  }
}
</style>
